/**
 * Lets a scripted scroll (a time-of-day jump) keep the phone header where it is.
 * The home page hides the header when you scroll down and brings it back when you
 * scroll up. Doing that in the middle of a jump moves the sticky "Jump to" bar and
 * leaves the section hidden under the header or short of where it should land.
 */

let holds = 0;
/** Goes up each time a hold ends; see headerHoldGeneration */
let releases = 0;

/** Keeps the header as it is until the returned release function is called. */
export function holdHeader(): () => void {
  holds += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holds = Math.max(0, holds - 1);
    releases += 1;
  };
}

export function isHeaderHeld(): boolean {
  return holds > 0;
}

/**
 * Changes after every hold ends. Scroll events from a jump can reach the header's handler
 * after the hold is over (when the page was in the background, for example); the handler
 * compares this with the value it last saw and, on a change, takes the current position as
 * its new starting point instead of treating the whole jump as the visitor scrolling.
 */
export function headerHoldGeneration(): number {
  return releases;
}
